// Registrazione del service worker generato da Workbox in build di produzione.
// Il file `service-worker.js` viene creato dal GenerateSW (vedi config-overrides.js)
// e in dev NON esiste: per questo registriamo solo in produzione.

type Config = {
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
    return;
  }

  // Se l'app è servita da un sotto-percorso diverso dall'origin del bundle,
  // il service worker non funzionerebbe: in quel caso non registriamo.
  const publicUrl = new URL(process.env.PUBLIC_URL || "", window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    return;
  }

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;

          installingWorker.onstatechange = () => {
            if (installingWorker.state === "installed") {
              if (navigator.serviceWorker.controller) {
                // Nuovo contenuto disponibile: verrà usato dopo la chiusura
                // di tutte le schede dell'app.
                config?.onUpdate?.(registration);
              } else {
                // Contenuto messo in cache per l'uso offline.
                config?.onSuccess?.(registration);
              }
            }
          };
        };
      })
      .catch((error) => {
        console.error("Registrazione service worker fallita:", error);
      });
  });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}
